import { useEffect } from 'react';
import { useAuthManager, useGtmService } from '@funtech-int/yango-shared';

import { clientConfig } from '@/config/client';

const { gtm } = clientConfig;

export function useInitGtm() {
    const gtmService = useGtmService();
    const authManager = useAuthManager();

    useEffect(() => {
        if (!gtmService) {
            return;
        }

        gtmService.initialize({
            userId: authManager.yandexuid,
            containerId: gtm?.containerId,
            source: gtm?.source,
        });
    }, [gtmService, authManager]);
}
